export const reverseGeocodeType = 'reverseGeocode';
export const crossStreetLookupType = 'reverseGeocode/crossStreet';
